import { nectarApi } from './client'
import type {
  CreateSessionResponse,
  JoinByCodeResponse,
  JoinResponse,
  MySessionsResponse,
  ReadyResponse,
  RestartResponse,
  StatusResponse,
  VoteResponse
} from './conversation-types'
export function extractApiError(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const resp = (err as { response?: { data?: { message?: string; error?: string } } }).response
    return resp?.data?.message || resp?.data?.error || fallback
  }
  return fallback
}

export const fetchMySessions = (projectId: string) =>
  nectarApi.get<MySessionsResponse>('/v1/conversations/sessions/mine', { projectId })

export const joinSession = (sessionId: string) =>
  nectarApi.post<JoinResponse>(`/v1/conversations/sessions/${sessionId}/join`)

export const joinSessionByCode = (inviteCode: string) =>
  nectarApi.post<JoinByCodeResponse>('/v1/conversations/sessions/join-by-code', { code:inviteCode })

export const fetchSessionStatus = (sessionId: string) =>
  nectarApi.get<StatusResponse>(`/v1/conversations/sessions/${sessionId}/status`)

export const signalReady = (sessionId: string) =>
  nectarApi.post<ReadyResponse>(`/v1/conversations/sessions/${sessionId}/ready`)

export const leaveSession = (sessionId: string) =>
  nectarApi.post<{ status: 'left' }>(`/v1/conversations/sessions/${sessionId}/leave`)

export const requestRestart = (sessionId: string) =>
  nectarApi.post<RestartResponse>(`/v1/conversations/sessions/${sessionId}/restart`)

export const voteRestart = (sessionId: string, restartId: string, vote: boolean) =>
  nectarApi.post<VoteResponse>(`/v1/conversations/sessions/${sessionId}/restart/${restartId}/vote`, { vote })

export const createPrivateSession = (projectId: string) =>
  nectarApi.post<CreateSessionResponse>(`/v1/conversations/sessions/projects/${projectId}/private`)

export const createPublicSession = (projectId: string) =>
  nectarApi.post<CreateSessionResponse>(`/v1/conversations/sessions/projects/${projectId}/public`)

export const submitLabels = (sessionId: string, answers: Record<string, number>) =>
  nectarApi.post<{ status: string }>(`/v1/conversations/sessions/${sessionId}/labels`, { answers })
